import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-commitments-tab-1-part',
	standalone: true,
	templateUrl: './configuration-commitments-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./configuration-commitments-tab-1.part.scss`],
})
export class ConfigurationCommitmentsTab1Part {
}
